module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-21-2f1c6dd6b82bb45d71addcd2dea28121.svg";